import { MeshBasicMaterial, Mesh, RingGeometry } from "three";
import { VBase } from "./VBase";
import VUtil from "../VUtils";

const defaultOptions = {
  map: null,
  fillMap: null,
  opacity: 1,
  fillOpacity: 1,
  color: 0x676767,
  fillColor: 0x00ffff,
  innerRadius: 0.07,
  outerRadius: 0.1,
  textSize: 0.05,
  textColor: 0x000000,
};

/*
  使用案例

    let bar = this.uiLib.createProgressBarRing();
      bar.setValue(0.5); // 设置进度值 0.0 - 1.0
      this.uiLib.addUIToScene(bar);
*/

export class VProgressBar2 extends VBase {
  /**
   * 创建环形进度条
   *   options:
   * {
   *      priority: 优先级，默认为1，值越小越靠前
   *      renderOrder: 渲染顺序，默认为99998
   *      map: 进度条背景图片，默认为null，不是地址
   *      fillMap: 进度条填充图片，默认为null，不是地址
   *      opacity: 背景透明度
   *      fillOpacity: 填充透明度
   *      color: 进度条背景色，默认为0x676767
   *      fillColor: 进度条填充颜色，默认为0x00ffff
   *      innerRadius: 内环半径，默认为1
   *      outerRadius: 外环半径，默认为1.2
   *      textSize: 文字大小，默认为0.05
   *      textColor: 文字颜色，默认为0x000000
   * }
   * @param {*} options
   */
  constructor(options, vuiLib) {
    if (!options) options = {};

    const tempOptions = {
      priority: options.priority !== undefined ? options.priority : 1,
      renderOrder:
        options.renderOrder !== undefined ? options.renderOrder : 99998,
      map: options.map ? options.map : defaultOptions.map,
      fillMap: options.fillMap ? options.fillMap : defaultOptions.fillMap,
      color: options.color !== undefined ? options.color : defaultOptions.color,
      opacity:
        options.opacity !== undefined
          ? options.opacity
          : defaultOptions.opacity,
      fillOpacity:
        options.fillOpacity !== undefined
          ? options.fillOpacity
          : defaultOptions.fillOpacity,
      fillColor:
        options.fillColor !== undefined
          ? options.fillColor
          : defaultOptions.fillColor,
      innerRadius:
        options.innerRadius !== undefined
          ? options.innerRadius
          : defaultOptions.innerRadius,
      outerRadius:
        options.outerRadius !== undefined
          ? options.outerRadius
          : defaultOptions.outerRadius,
      textSize:
        options.textSize !== undefined
          ? options.textSize
          : defaultOptions.textSize,
      textColor:
        options.textColor !== undefined
          ? options.textColor
          : defaultOptions.textColor,
    };

    super(tempOptions, vuiLib);
    this._vType = "VProgressBar2";
    this.lastValue = 0;
    this._otherProps = {
      innerRadius: tempOptions.innerRadius,
      outerRadius: tempOptions.outerRadius,
      fillColor: tempOptions.fillColor,
      fillMap: tempOptions.fillMap,
      fillOpacity: tempOptions.fillOpacity,
    };

    this.name = "VProgressBar2";

    // 修改矩形几何体为圆环
    this.geometry = new RingGeometry(
      this._otherProps.innerRadius,
      this._otherProps.outerRadius,
      32,
      1,
      Math.PI / 2,
      Math.PI * 2
    );

    // fill
    const geo1 = new RingGeometry(
      this._otherProps.innerRadius,
      this._otherProps.outerRadius,
      32,
      1,
      Math.PI / 2,
      0
    );
    const mat1 = new MeshBasicMaterial({
      color: this._otherProps.fillColor,
      map: this._otherProps.fillMap,
      transparent: true,
      opacity: this._otherProps.fillOpacity,
      depthTest: this.depthTest,
    });
    VUtil.convertSRGBToLinear(mat1);

    this.fill = new Mesh(geo1, mat1);
    this.fill.renderOrder = this._baseProps.renderOrder;
    this.add(this.fill);

    // text
    this.text = VUtil.createText(
      "0%",
      this._textProps.textSize,
      this._textProps.textColor,
      "normal"
    );

    this.text.renderOrder = this._baseProps.renderOrder;
    this.add(this.text);

    // 创建的环形有点拉伸 感觉是距离相机太近导致的，所有形状在y轴上都会有拉升变形，暂时忽略
    //this.scale.y = 0.85;

    this.width = this._otherProps.outerRadius * 2;
    this.height = this._otherProps.outerRadius * 2;
  }

  /**
   * 设置进度值
   * @param {Number} value 0到1的小数值
   */
  setValue(value) {
    value = Math.max(0, Math.min(value, 1));

    value = Math.round(value * 100) / 100;

    if (this.lastValue === value) return;

    this.lastValue = value;

    const theta = value * Math.PI * 2;
    this.fill.geometry.dispose();
    this.fill.geometry = new RingGeometry(
      this._otherProps.innerRadius,
      this._otherProps.outerRadius,
      32,
      1,
      Math.PI / 2,
      theta
    );

    this.text.geometry.dispose();
    this.text.material.dispose();
    this.text.removeFromParent();
    let string = value * 100 + "";
    if (string.length > 2) string = string.substring(0, 2);
    this.text = VUtil.createText(
      string + "%",
      this._textProps.textSize,
      this._textProps.textColor,
      "normal"
    );
    this.text.renderOrder = this._baseProps.renderOrder;
    this.add(this.text);
  }

  // 此对象不需要点击交互
  getClickable() {
    return [];
  }
}
